import { useCallback } from 'react';
import { useLocalStorage } from './useLocalStorage';
import { useIsPaidPortal } from './useProductInventory';
import { useIsInAppAuth, useIsPartnerProgramEligible } from './useUserInfo';
const BANNER_DISMISSED_KEY = 'partner-program:dismissed-banner';
export const usePartnerProgramBanner = () => {
  const isInAppAuth = useIsInAppAuth();
  const isPartnerProgramEligible = useIsPartnerProgramEligible();
  const {
    isPaidPortal,
    loading: isInventoryLoading
  } = useIsPaidPortal();
  const [isBannerDismissed, setIsBannerDismissed] = useLocalStorage(BANNER_DISMISSED_KEY);
  const shouldShowPartnerProgramBanner = isInAppAuth && isPartnerProgramEligible && !isPaidPortal && !isInventoryLoading && !isBannerDismissed;
  const dismissBanner = useCallback(() => {
    setIsBannerDismissed('true');
  }, [setIsBannerDismissed]);
  return {
    shouldShowPartnerProgramBanner,
    dismissBanner
  };
};